import Vue from 'vue'
import vuex from 'vuex'

import login from './login-store'
import isTrans from './isTrans'
import common from './common-store'

Vue.use(vuex)

export default new vuex.Store({
  modules: {
    login,       // 和登录挂钩
    isTrans,
    common       // 全局公共变量
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js